module.exports = __webpack_public_path__ + "static/infinite-scrolling-example.54670c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/examples/infinite-scrolling-example.png
// module id = 2536
// module chunks = 41318205152459